'use client'

import { useEffect, useRef } from 'react'
import { useTrackFlowStepViewed } from '@nwwp/segment-analytics'
import { ALL_TRACKING_PARAMETERS } from '@nwwp/utils'
import { useFunnelStore } from '../../_hooks/use-funnel-store'

const allowedTrackingKeys: readonly string[] = ALL_TRACKING_PARAMETERS

export const FlowStepViewed = ({
  children,
  step,
  type,
  enabled = true,
}: {
  children: React.ReactNode
  step: string
  type: string
  enabled?: boolean
}) => {
  const trackFlowStepViewed = useTrackFlowStepViewed()
  const emitted = useRef(false)

  useEffect(() => {
    if (!enabled) return
    if (emitted.current) return

    emitted.current = true
    const tracking = useFunnelStore.getState().tracking
    const filteredTracking = Object.fromEntries(
      Object.entries(tracking).filter(([key]) => allowedTrackingKeys.includes(key))
    )

    trackFlowStepViewed({ step, type, ...filteredTracking })
  }, [trackFlowStepViewed, step, type, enabled])

  return children
}
